import './index.scss'


const Qualities = () => {

    return (
        <div className='qualities-container'>
            <h1 className='big first up one'>
                Driven
            </h1>
            <h1 className='big first right two'>
                Ambitious
            </h1>
            <h1 className='big first left three'>
                Confident
            </h1>
            <h1 className='medium later down four'>
                Hardworking
            </h1>
            <h1 className='medium later up five'>
                Creative
            </h1>
            <h1 className='medium later right six'>
                Attentive
            </h1>
            <h1 className='medium later left seven'>
                Communicative
            </h1>
            <h1 className='medium later down eight'>
                Collaborative
            </h1>
            <h1 className='small last up nine'>
                Punctual
            </h1>
            <h1 className='small last right ten'>
                Thorough
            </h1>
            <h1 className='small last left eleven'>
                Practical
            </h1>
            <h1 className='small last down twelve'>
                Adaptable
            </h1>
            <h1 className='small last up thirteen'>
                Loyal
            </h1>
            <h1 className='small last right fourteen'>
                Committed
            </h1>
            <h1 className='small last left fifteen'>
                Flexible
            </h1>
        </div>
    )
}

export default Qualities